import React from 'react';
import { WebUiButton } from 'src/modules/web-ui/components/button';
import { WebUiInput } from 'src/modules/web-ui/components/input';

import { postWebUiApi } from '../../../api';
import type { SystemId, SystemInfo } from './c-system-settings-types';

type Props = {
  readonly: boolean;
  systemId: SystemId;
  info: SystemInfo;
  setInfo: React.Dispatch<React.SetStateAction<SystemInfo>>;
  runSet: (fn: () => Promise<void>, ok: string) => void;
};

export default function CSystemSystemInfoPanel({
  readonly,
  systemId,
  info,
  setInfo,
  runSet,
}: Props) {
  return (
    <div className="flex flex-col gap-2">
      <h4 className="font-bold">System Info</h4>
      <table className="webui-table w-full">
        <thead>
          <tr className="webui-table-row-head">
            <th>System</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr className="webui-table-row-content">
            <td>Name</td>
            <td>{info.name ?? '-'}</td>
          </tr>
          <tr className="webui-table-row-content">
            <td>Serial Number</td>
            <td>{systemId.sn ?? '-'}</td>
          </tr>
          <tr className="webui-table-row-content">
            <td>Software Version</td>
            <td>{systemId['sw version'] ?? '-'}</td>
          </tr>
          <tr className="webui-table-row-content">
            <td>Management MAC</td>
            <td>{systemId['mgmt mac'] ?? '-'}</td>
          </tr>
          <tr className="webui-table-row-content">
            <td>Description</td>
            <td>
              <WebUiInput
                className="w-full"
                inputSize="sm"
                disabled={readonly}
                value={info.description ?? ''}
                onChange={(e) =>
                  setInfo((p) => ({ ...p, description: e.target.value }))
                }
              />
            </td>
          </tr>
          <tr className="webui-table-row-content">
            <td>Contact</td>
            <td>
              <WebUiInput
                className="w-full"
                inputSize="sm"
                disabled={readonly}
                value={info.contact ?? ''}
                onChange={(e) =>
                  setInfo((p) => ({ ...p, contact: e.target.value }))
                }
              />
            </td>
          </tr>
          <tr className="webui-table-row-content">
            <td>Location</td>
            <td>
              <WebUiInput
                className="w-full"
                inputSize="sm"
                disabled={readonly}
                value={info.location ?? ''}
                onChange={(e) =>
                  setInfo((p) => ({ ...p, location: e.target.value }))
                }
              />
            </td>
          </tr>
        </tbody>
      </table>
      <div>
        <WebUiButton
          disabled={readonly}
          onClick={() =>
            runSet(
              () =>
                postWebUiApi({
                  service: 'system',
                  access: 'set',
                  command: 'set info',
                  parameters: {
                    description: info.description ?? '',
                    location: info.location ?? '',
                    contact: info.contact ?? '',
                  },
                }),
              'System information updated.',
            )
          }
        >
          Set System Info
        </WebUiButton>
      </div>
    </div>
  );
}
